import styled from 'styled-components'

export const TituloSumario = styled.div`
  display: flex;
  text-align: center;
  margin-top: 20px;
  border-bottom: 1px solid #ccc;
  justify-content: center;

  @media (min-width: 1024px) {
    justify-content: center;
  }
  img {
    margin-left: 20px;
  }
`
